import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import './Legal.css';

function Unsubscribe() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [confirming, setConfirming] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    setError('');

    try {
      await api.deleteMyData();
      setSuccess(true);
      setTimeout(() => {
        logout();
        navigate('/login');
      }, 3000);
    } catch (err) {
      setError(err.message || 'Failed to delete data');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="legal-page">
        <div className="legal-container">
          <div className="unsubscribe-card">
            <div className="success-icon">&#10003;</div>
            <h2>Data Deleted Successfully</h2>
            <p>Your account and all associated data have been permanently deleted.</p>
            <p className="redirect-message">Redirecting to login page...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to={user ? '/' : '/login'} className="back-link">
          {user ? 'Back to Home' : 'Back to Login'}
        </Link>

        <div className="unsubscribe-card">
          <h1>Delete My Data</h1>

          {!user ? (
            <div className="not-logged-in">
              <p>You need to be logged in to delete your data.</p>
              <Link to="/login" className="btn btn-primary">
                Login
              </Link>
            </div>
          ) : confirming ? (
            <>
              <div className="warning-box">
                <h3>Are you absolutely sure?</h3>
                <p>This action cannot be undone. This will permanently delete:</p>
                <ul>
                  <li>Your account</li>
                  <li>All your predictions</li>
                  <li>Your group memberships</li>
                  <li>All associated data</li>
                </ul>
              </div>

              {error && <div className="error-message">{error}</div>}

              <div className="confirm-actions">
                <button
                  className="btn btn-secondary"
                  onClick={() => setConfirming(false)}
                  disabled={loading}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-danger"
                  onClick={handleDelete}
                  disabled={loading}
                >
                  {loading ? 'Deleting...' : 'Yes, Delete Everything'}
                </button>
              </div>
            </>
          ) : (
            <>
              <p className="unsubscribe-info">
                If you wish to delete your account and all associated data, click the button below.
                This action is permanent and cannot be undone.
              </p>

              <div className="data-summary">
                <h3>Data that will be deleted:</h3>
                <ul>
                  <li>Account information (name, email)</li>
                  <li>All predictions you've made</li>
                  <li>Group memberships</li>
                  <li>Push notification subscriptions</li>
                </ul>
              </div>

              <button
                className="btn btn-danger"
                onClick={() => setConfirming(true)}
              >
                Delete My Data
              </button>

              <p className="contact-info">
                For other data inquiries, contact us through the application.
              </p>
            </>
          )}
        </div>

        <div className="legal-footer">
          <Link to="/terms">Terms of Service</Link>
          <span>|</span>
          <Link to="/privacy">Privacy Policy</Link>
        </div>
      </div>
    </div>
  );
}

export default Unsubscribe;
